import React, { useState, useEffect } from "react"
import CustomTextField from '../../StandardComponents/CustomTextField';
import BasicDatePicker from '../../StandardComponents/BasicDatePicker';



import { makeStyles } from '@material-ui/core/styles';
import { db } from "../../../firebase"
import { useAuth } from "../../../contexts/AuthContext"

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';

import { Typography } from "@material-ui/core";
import GeneralViewContainer from "../../StandardComponents/GeneralViewContainer";
import * as database from '../../../constants/database'


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  snack: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  progressbar: {
    position: 'absolute',
    zIndex : '1000',
    width: '10%',
    height: '100%',
  }

  
}));



function notEmpty(val){
  if(val)
  {
    return true;
  }
  return false;
}



var invoiceOtherNotesBefore = "";
var invoiceOtherNotesLive = "";


export default function Notes(props) {



  const { currentUser } = useAuth()

  var userRef = db.collection("users").doc(currentUser.uid);
  var documentsRecordsRef = userRef.collection(database.TABLE_NAME_INVOICES);


  var specificItemRef;

  function setQuery(){

    var docId = localStorage.getItem('doId');
    console.log("WILL NOW SEARCH ID: " +localStorage.getItem('itId'));
    if(!docId)
    {
       props.startSnackBar(true, 20000,"No Contact Provided","error",true)
        return;
    }
    specificItemRef = documentsRecordsRef.doc(docId);
    
  }


  var [loading, setLoading] = useState(false)


  const [invoiceOtherNotes, setinvoiceOtherNotes] = useState("")

 


  const [open, setOpen] = React.useState(false);
  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };



  async function writeUserData() {
    setLoading(true)
    return specificItemRef.set({
      invoiceOtherNotes: invoiceOtherNotes
    },{ merge: true })
    .then(() => {
      setLoading(false)
      setError("")

      
      props.setSaveState(false);

      props.startSnackBar(true, 2000,"Saved","success",true)

      invoiceOtherNotesBefore = invoiceOtherNotesLive
  })
  .catch((error) => {
      props.startSnackBar(true, 20000,"Failed to get data. "+error.code,"error",true)

      setLoading(false)
  });
  }





  const fetchData=async()=>{
  return specificItemRef.get().then((doc) => {
    if (doc.exists) {
 
        if(doc.data().invoiceOtherNotes)
        {
          setinvoiceOtherNotes(doc.data().invoiceOtherNotes);
          invoiceOtherNotesBefore = doc.data().invoiceOtherNotes;
          invoiceOtherNotesLive = doc.data().invoiceOtherNotes;
        }
       

    } else {
      props.startSnackBar(true, 20000,"No such data","error",true)

    }
}).catch((error) => {
  props.startSnackBar(true, 20000,"Problem getting data. "+error.code,"error",true)

});

}



useEffect(async () => {
  props.handleLoadingState(loading)
}, [loading])


useEffect(async () => {
  
  if(props.activateSave)
  {
    handleSaveData()
  }

}, [props.activateSave])


useEffect(async () => {
  // Update the document title using the browser API
  props.pageDisplayStatus((pageState) => ({...pageState, backButton:true, mainTab:false, invoiceEstimateTab:false, edPrHiTab: false}))

  setLoading(true)
  
try{
  setError("")
  setQuery()
  fetchData();
  props.setSaveState(false);
}
catch(error){
  props.startSnackBar(true, 20000,"Failed to get data. "+error.code,"error",true)
}
  setLoading(false)
}, [])

  function checkForChanges(){

    if((invoiceOtherNotesLive!==invoiceOtherNotesBefore))
    {
      props.setSaveState(true);
    }
    else
    {
      props.setSaveState(false);
    }
  }


  const classes = useStyles();

  const [error, setError] = useState("")

  function handleSaveData(){
 
    setQuery()
    writeUserData()
 
  }


function enterKeyDown(val){
  if (val && props.currentSaveState) {
    handleSaveData();
    }
}

  const updateText = (e)=> {

    switch(e.target.id) {
      case "invoiceOtherNotes":
        setinvoiceOtherNotes(e.target.value);
        invoiceOtherNotesLive = e.target.value;
      break;
    }

    checkForChanges();
  };





  return (
    <>

<GeneralViewContainer maxWidth="lg">
      <Grid container spacing={1}>

        <Grid item xs={12}>
        <Typography variant="h5" component="h5">Notes</Typography>
        </Grid>

        <Grid item xs={12}>
        <Box borderTop={1} borderColor="primary.main">
        </Box>
        </Grid>


  <Grid item xs={12}>
      <Tooltip title="Notes">
  <CustomTextField multiline rows={10} disabled={notEmpty(error)} updateText={updateText}  id="invoiceOtherNotes" label="Notes" value={invoiceOtherNotes} enterKeyDown={enterKeyDown}/>
  </Tooltip>
  </Grid>


      
    </Grid>
    </GeneralViewContainer>

    </>
  )
}
